import Component from 'flarum/Component';
import FormGroup from './FormGroup';

/* global m */

export default class DiscreetInput extends Component {
    view() {
        if (this.props.editable) {
            const vnode = m('input.FormulaireDiscreetInput', {
                value: this.props.value,
                onchange: event => {
                    this.props.onchange(event.target.value);
                },
                placeholder: this.props.placeholder,
                title: this.props.title,
            });

            // Wrap into the form-group to re-use the error message logic
            // Only do it when there's actually an error as this breaks the layout
            if (this.props.validationErrors) {
                return FormGroup.component({
                    validationErrors: this.props.validationErrors,
                }, vnode);
            }

            return vnode;
        }

        return m('span.FormulaireDiscreetInput', {
            title: this.props.title,
        }, this.props.value || this.props.placeholder);
    }
}
